import { EducationModule } from "@js/components/EducationCourse/eduConfig";
import { level1ModuleCompleteColor } from "@js/educationContent/CairoMummiesContent/eduConstants";
import Ribbon0 from "@js/public/images/Ribbon0.svg";
import StarklingsLogo from "@js/public/images/StarklingsLogo.svg";
import {
    lesson0DefaultEndCode,
    lesson0DefaultMiddleCode,
    lesson0DefaultStartCode,
} from "./lesson0";
import {
    lesson1DefaultEndCode,
    lesson1DefaultMiddleCode,
    lesson1DefaultStartCode,
} from "./lesson1";
import { m3l0Solution } from "./lesson0Solution";
import { m3l1Solution } from "./lesson1Solution";

export const starklings1OperationsConfig: EducationModule = {
    solution: "",
    imgSrc: StarklingsLogo.src,
    moduleInfo: {
        id: 3,
        moduleName: "starklings1Operations",
        timeEstimate: "5-10 min",
        title: "Starklings 1.0  Operations",
        description: `Welcome to the intro of Starklings 1.0 Operations lessons. Good luck!`,
        moduleComplete: {
            badgeName: "STARKLINGS 1.0 OPERATIONS",
            badgeCaption: "A level 1 Starkling 1.0",
            ribbonImgSrc: Ribbon0.src,
            badgeImgSrc: StarklingsLogo.src,
            imgColor: level1ModuleCompleteColor,
            badgeTokenId: 16,
        },
    },
    lessons: [
        {
            timeEstimate: "5 min",
            title: "Operations00",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "A field element - felt, is a native type in Cairo. Learn more about it in the " }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html#felt-type", "children": [ { "text": "Cairo book" } ] }, { "text": " to learn more about it" } ] }, { "type": "paragraph", "children": [ { "text": "Cairo1 has native integer types which support more operators then felts, like %, / Take a look " }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html#integer-types", "children": [ { "text": "here" } ] }, { "text": " for more details" } ] } ]
`,
            hints: [],
            defaultStartCode: lesson0DefaultStartCode,
            defaultMiddleCode: lesson0DefaultMiddleCode,
            defaultEndCode: lesson0DefaultEndCode,
            id: 0,
            solution: m3l0Solution,
        },
        {
            timeEstimate: "5 min",
            title: "Operations01",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "A field element - felt, is a native type in Cairo. Learn more about it in the " }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html#felt-type", "children": [ { "text": "Cairo book" } ] }, { "text": " to learn more about it" } ] }, { "type": "paragraph", "children": [ { "text": "Cairo1 has native integer types which support more operators then felts, like %, / Take a look " }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html#integer-types", "children": [ { "text": "here" } ] }, { "text": " for more details" } ] } ]
`,
            hints: [],
            defaultStartCode: lesson1DefaultStartCode,
            defaultEndCode: lesson1DefaultEndCode,
            defaultMiddleCode: lesson1DefaultMiddleCode,
            id: 1,
            solution: m3l1Solution,
        },
    ],
};
